/**
 * Texts of the ui primitives (no i18n binding at this layer): English by default, `configureUiTexts` swaps them (e.g.
 * `uiTextsSv`, or functions over the app's `t`). Each is a function, so a language switch shows at the next render.
 */
export const uiTexts = {
  /** A searchable list with nothing matching the typed text. */
  noMatch: () => 'No match',
  /** A required combobox without a value (its validity message). */
  required: () => 'Choose a value.',
  /** The option that adds a typed value (`MultiSelect creatable`). */
  add: (value: string) => `Add “${value}”`,
  /** A server search still running. */
  loading: () => 'Loading…',
  /** A chip's remove button. */
  remove: (label: string) => (label ? `Remove ${label}` : 'Remove'),
};

export type UiTexts = typeof uiTexts;

export function configureUiTexts(texts: Partial<UiTexts>) {
  Object.assign(uiTexts, texts);
}

export const uiTextsSv: UiTexts = {
  noMatch: () => 'Ingen träff',
  required: () => 'Välj ett värde.',
  add: (value) => `Lägg till ”${value}”`,
  loading: () => 'Laddar…',
  remove: (label) => (label ? `Ta bort ${label}` : 'Ta bort'),
};
